import { Map, List } from 'immutable';
import actions from '../../constants/portal/news';


const defaultState = () => new Map({
  newsList: undefined,
  newsDetail: null,
  
  newsItem: new Map(),
  attachedFiles: new List([]),

  newsTags: undefined,
  allNewsTagsAreLoading: true,

  newsContent: null,
  contentByNewsIsLoading: true,

  newsAreLoading: false,

  tagsByNews: new Map(),
  tagsByNewsAreLoading: true,

  newsAdminList: new Map(),
  newsAdminListAreLoading: false,
  newIsSubmitting: false
})

export default (state = defaultState(), action) => {
  switch (action.type) {
    case actions.LOAD_NEWS:
      return state.set('newsList', action.data);

    case actions.LOAD_NEWS_DETAIL:
      return state.set('newsDetail', action.data);
      
    case actions.NEWS_ARE_LOADING:
      return state.set('newsAreLoading', action.data);

    case actions.SET_NEWS_ITEM_VALUE:
   
      if (typeof(action.key) === ( "string" || 'number')) {
        return state.setIn(['newsDetail', action.key], action.data);
      } else {
        return state.setIn(['newsDetail', ...action.key], action.data);
      }
      
      
    case actions.ADD_TITLE_IMAGE_TO_NEWS:
      return state.setIn(['newsDetail', 'image'], action.data);
    case actions.ADD_FILES_TO_NEWS:
        return state.set('attachedFiles', new List(action.data));

    case actions.LOAD_NEWS_TAGS:
      return state.set('newsTags', action.data);
    case actions.ALL_NEWS_TAGS_ARE_LOADING:
      return state.set('allNewsTagsAreLoading', action.data);

    case actions.LOAD_TAGS_BY_NEWS:
      return state.set('tagsByNews', action.data);
    case actions.TAGS_BY_NEWS_ARE_LOADING:
      return state.set('tagsByNewsAreLoading', action.data);

    case actions.LOAD_NEWS_CONTENT:
      return state.set('newsContent', action.data);
    case actions.CONTENT_BY_NEWS_IS_LOADING:
      return state.set('contentByNewsIsLoading', action.data);
    
    case actions.LOAD_ADMIN_NEWS:
      return state.set('newsAdminList', action.data);
    case actions.NEWS_ADMIN_ARE_LOADING:
      return state.set('newsAdminListAreLoading', action.data);

    case actions.ATTACH_FILE_TO_NEWS:
      return state.setIn(['newsFiles', action.data.name], action.data.file);
    case actions.NEW_IS_SUBMITTING:
      return state.set('newIsSubmitting', action.data)

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/portal/news.js